import script from "./OrderHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistory.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistory.vue?vue&type=style&index=0&id=de03eb72&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de03eb72"]])

export default __exports__